import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/cash_flow/workload/currencies"

export class GetCurrenciesInWorkloadDbTableCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<string[]> {
        var res = await this.executeCommand();
        return res.data.Payload.Currencies;
    }

}
